export let suggestionsTemplate =
    `<div class="u-white-bg c-typeahead-suggestion">
        <div v-if="result && result.title" class="c-result-item">
           <span>{{ result.title }}</span>
         </div>
    </div>`
